var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2C6.692 2 4 4.71056 4 8.0431C4 12.7782 9.436 17.6674 9.66733 17.8727C9.75877 17.9546 9.87715 17.9999 9.99987 18C10.1226 18.0001 10.2411 17.9551 10.3327 17.8734C10.564 17.6674 16 12.7782 16 8.0431C16 4.71056 13.308 2 10 2ZM10 11.333C8.162 11.333 6.66667 9.8377 6.66667 7.99977C6.66667 6.16184 8.162 4.66656 10 4.66656C11.838 4.66656 13.3333 6.16184 13.3333 7.99977C13.3333 9.8377 11.838 11.333 10 11.333Z",
    fill: "#656E74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLocationIcon);
export default __webpack_public_path__ + "static/media/dark-location-icon.1da736f24f231f142606249c10a6238d.svg";
export { ForwardRef as ReactComponent };